// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__2geTk","content":"Faq_content__3eUiU","title":"Faq_title__26xPt"};